/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import FacilityAutoComplete from "../common/FacilityAutoComplete";

import { updateFilters } from "../../slices/filtersSlice";
import PropTypes from "prop-types";

const LocationFilter = ({
  placeholder,
}) => {
  const facilityId = useSelector((state) => {
    return state.filters.facilityId;
  });

  const facilityName = useSelector((state) => {
    return state.filters.facilityName;
  });

  const facilitySlic = useSelector((state) => {
    return state.filters.facilitySlic;
  });

  const facilityAlpha = useSelector((state) => {
    return state.filters.facilityAlpha;
  });

  const dispatch = useDispatch();
  const history = useHistory();

  const handleChange = (event, option) => {
    // pass null if empty string to avoid adding query string param
    dispatch(
      updateFilters({
        filters: {
          facilityId: option ? option.id : null,
          facilityName: option ? option.name : null,
          facilitySlic: option ? option.slicCode : null,
          facilityAlpha: option ? option.alphaCode : null,
        },
        history,
      })
    );
  };

  return (
    <FacilityAutoComplete
      handleChange={handleChange}
      selectedFacility={{
        id: facilityId,
        name: facilityName,
        slicCode: facilitySlic,
        alphaCode: facilityAlpha,
      }}
      label={"Any " + placeholder}
      focusedLabel={placeholder}
      width={165}
    />
  );
};

LocationFilter.propTypes = {
  placeholder: PropTypes.string,
};


export default LocationFilter;
